export enum TypeOfFlight {
	international = 'international',
	domestic = 'domestic',
}
